export const COMMON_BOOKING_FEATURE_KEY = 'commonBooking';
